import { Stack } from "@mui/material";
import { Moneda } from "@/shared/types/moneda";
import { Form } from "@/components/form";

export interface MontoFieldModalFormNormalFieldsProps {
    monedas: Moneda[],
    allowNegative?: boolean,
    decimalScale?: number,
}

export default function MontoFieldModalFormNormalFields({
    monedas,
    allowNegative,
    decimalScale
}: MontoFieldModalFormNormalFieldsProps) {
    return monedas.map((m, i) => <Stack key={m.id} direction={"row"} alignItems={"center"} gap={3}>
        <Stack flex={1} minWidth={"150px"}>
            <Form.MonedaField
                size="small"
                name={`items[${i}].cantidad`}
                label={m.nombre}
                monedaId={m.id}
                allowNegative={allowNegative}
                decimalScale={decimalScale}
            />
        </Stack>
    </Stack>)
}